import Slide from "./Slide";

export { Slide };
